import { UPDATE_SEARCHTDATA_CHOTHANHTOAN } from "../../../actions/TichHopBank/DanhSachTaiKhoanBank/actionTypes";
import {currentDate } from "utils/formatDate";
const initialState = {
  sSearch:"",
  sTrangThai : "",
  iPageIndex: 1,
  iPageSize: 25,
  iLoaiChoVay: 0,
  TuNgay: currentDate(),
  DenNgay: currentDate()
};
const updateDataSearch = (state, action) => ({
  ...action.payload,
});

export const dataSearchChoThanhToanReducer = (state = initialState, action) => {
  switch (action.type) {
    case UPDATE_SEARCHTDATA_CHOTHANHTOAN:
      return updateDataSearch(state, action);
    default:
      return state;
  }
};

export default dataSearchChoThanhToanReducer;
